import AdminDistrict from './AdminDistrict';
export default AdminDistrict;
